import React from 'react'
import { FormatDate, FormatUtcDateAsLocal } from '../../../../../../helpers/datetime'
import * as Badges from '../../../../../../components/badges'
import PropTypes from "prop-types"

const PoolNextAvailablePickupChanged = (props) => {
  let data
  let payload = JSON.parse(props.item.payload)
  switch (payload.Availability) {
  case 'limited':
    data = <span>{'Limited pickup availability. Next available pickup is ' + FormatDate(payload.NextAvailableDelivery)}</span>
    break
  case 'immediate':
    data = <span>{'Immediate pickup available'}</span>
    break
  case 'none':
    data = <span>{'There are no remaining deliveries available today'}</span>
    break
  default:
    data = <span>{'Pickup availability is ' + payload.Availability + '. Next available pickup is ' + FormatDate(payload.NextAvailableDelivery)}</span>
    break
  }

  return <tr>
    <td><Badges.PickupChanged /></td>
    <td>{data}</td>
    <td>{FormatUtcDateAsLocal(props.item.createdUtc)}</td>
    <td>{props.item.createdBy}</td>
  </tr>
}

PoolNextAvailablePickupChanged.propTypes = {
  item: PropTypes.object
}

export default PoolNextAvailablePickupChanged


// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/poolNextAvailablePickupChanged/index.js